import React from "react";

// Reusable StatCard component for statistics
export const StatCard = ({ title, value, subtitle, tone = "violet" }) => (
  <div className="rounded-xl border border-white/10 bg-white/[0.08] p-4 text-center">
    <div className="text-sm text-slate-300">{title}</div>
    <div className={`text-3xl font-bold ${tone === "emerald" ? "text-emerald-400" : tone === "rose" ? "text-rose-400" : "text-violet-400"}`}>
      {value}
    </div>
    {subtitle && <div className="text-xs text-slate-400">{subtitle}</div>}
  </div>
);
